// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2QbEq","content":"styles_content__z1NRP","checkbox":"styles_checkbox__vuJuA","checkboxLabel":"styles_checkboxLabel__3ltrD"};